import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRouteSnapshot, Router, RouterModule } from '@angular/router';
import {
  GUID_REGEX,
  convertKebabCaseToTitleCase,
  singularizeResourceName,
} from 'utils';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HlmIconComponent } from '../icon';

@Component({
  selector: 'ctx-page-header',
  standalone: true,
  imports: [CommonModule, HlmIconComponent, MatTooltipModule, RouterModule],
  templateUrl: './page-header.component.html',
})
export class CtxPageHeaderComponent {
  @Input({ required: true }) activatedRoute: ActivatedRouteSnapshot;
  @Input() helperText?: string;

  /**
   * Since all titles have the | Cryptlex suffix, this removes the suffix
   * to show in headings.
   */
  get title() {
    return this.activatedRoute.title?.replace(' | Cryptlex', '');
  }
  breadcrumbs: { label: string; link: string }[] = [];

  ngOnInit() {
    this.breadcrumbs = this.setBreadcrumbs();
  }
  constructor(private router: Router) {}
  /**
   * Generates labels and links for Breadcrumbs and assigns to the current object.
   */
  setBreadcrumbs() {
    // Get the Current URL from RouterEvent
    let currentUrl = this.router.url.split(/[?#]/)[0];

    // If URL starts with '/', remove the '/'
    if (currentUrl.startsWith('/')) {
      currentUrl = currentUrl.slice(1);
    }

    // Split slash-separated URL path into an Array. Remove the queryparams.
    const urlSegments = currentUrl.split('/');

    return urlSegments.map((value, index, array) => {
      return {
        /**
         * Convert the split URL segments into an Array of prettified strings. Converts the kebab-case segments to
         * Title Case, and converts any Id based string to an appropriate word.
         */
        label: this.renameIdLabels(value, index, array),
        /**
         * Generate links for each breadcrumb using a map-reduce.
         */
        link: this.generateBreadcrumbHref(value, index, array),
      };
    });
  }

  /**
   * Callback function for generating breadcrumb hrefs using Array.prototype.map().
   *
   * Since this method gets called on array with separated strings that make up the URL,
   * this callback aims to generate the correct link for each breadcrumb link.
   */
  private generateBreadcrumbHref(str: string, index: number, array: string[]) {
    return '/'.concat(array.slice(0, index + 1).join('/'));
  }

  /**
   * Callback function for generating labels for ID based links.
   *
   * For an ID based link, the singular word for it's route predecessor is assigned.
   *
   * Example: for [..., 'Products', '3214212313', ...]
   * returns [..., 'Products', 'Product', ...]
   */
  private renameIdLabels(str: string, index: number, array: string[]): string {
    if (GUID_REGEX.test(str)) {
      return convertKebabCaseToTitleCase(
        singularizeResourceName(array[index - 1])
      );
    } else {
      return convertKebabCaseToTitleCase(str);
    }
  }
}
